<div id="newFolderModal">
  <form (ngSubmit)="ok()">
    <dialog-header>Create Folder</dialog-header>
    <mat-dialog-content>
      <div class="form-group">
        <label for="newFolderInput">Folder Name:</label>
        <input
          id="newFolderInput"
          type="text"
          class="form-control"
          value=""
          name="folderName"
          [(ngModel)]="folderName"
          placeholder="Enter Folder Name"
          (focus)="duplicateFolderSpecified = false"
          [focusMe]="{ delay: 250 }"
          [disabled]="waitingForResponse"
        />
        <br />
        @if (duplicateFolderSpecified) {
          <notification-alert
            id="duplicate-folder-error"
            type="danger"
            title="A Folder already uses that name, please choose a different one."
          >
          </notification-alert>
        }
        @if (accessDenied && accessDeniedMessage) {
          <notification-alert
            id="access-denied-error"
            type="danger"
            [title]="accessDeniedMessage"
          >
          </notification-alert>
        }
        @if (accessDenied && !accessDeniedMessage) {
          <notification-alert
            id="permission-denied-error"
            type="danger"
            title="You don't have permission to do this."
          >
          </notification-alert>
        }
        @if (serverError) {
          <notification-alert
            id="server-error"
            type="danger"
            [title]="'An error has occured. ' + respCode"
          >
          </notification-alert>
        }
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button
        rv-button
        variant="secondary"
        id="newFolderModalCancelButton"
        type="button"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button
        rv-button
        id="newFolderModalSaveButton"
        type="submit"
        [disabled]="
          !folderName || accessDenied || serverError || waitingForResponse
        "
      >
        Save
      </button>
    </mat-dialog-actions>
  </form>
</div>
